import Api from "@app/api/Api.js";
import CartProductVariationItem from "@app/react/components/CartProductVariationItem/CartProductVariationItem.jsx";
import CartRemoveItemConfirmationModal from "@app/react/components/Cart/CartRemoveItemConfirmationModal.jsx";
import InvalidQtyMessage from "@app/react/components/InvalidQtyMessage/InvalidQtyMessage.jsx";
import Price from "@app/react/components/Price/Price.jsx";
import React from 'react';
import './styles.scss';

export default function Cart({data}) {
  const [initialCart, setInitialCart] = React.useState(data)
  const [cart, setCart] = React.useState(data)
  const [updated, setUpdated] = React.useState(false)
  const [showRemoveModal, setShowRemoveModal] = React.useState(false)
  const [itemIdToRemove, setItemIdToRemove] = React.useState(null)
  const [checkout, setCheckout] = React.useState(null)

  React.useEffect(() => {
    if (cart?.id) {
      Api.get(`api/checkout/${cart.id}`).then(response => {
        setCheckout(response.checkout)
      })
    }
  }, [cart])

  function handleCartUpdate(id, qty) {
    setCart(prev => {
      const newCart = structuredClone(prev)
      newCart.items.find(item => item.id === id).quantity = qty
      setUpdated(true)
      return newCart
    })
  }

  function handleDeleteItem(id) {
    const cartItems = []
    for(const item of cart.items) {
      cartItems.push({
        id: item.id,
        quantity: item.id === id ? 0 : item.quantity,
      })
    }

    Api.patch('api/cart', {items: cartItems}).then(
      response => {
        setCart(response.cart);
        setInitialCart(response.cart);
        setUpdated(false);
      }
    );
  }

  function handleResetCart() {
    setCart(initialCart);
    setUpdated(false);
  }

  function handleSaveCart() {
    const cartItems = []
    for(const item of cart.items) {
      cartItems.push({
        id: item.id,
        quantity: item.quantity
      })
    }

    Api.patch('api/cart', {items: cartItems}).then(
      response => {
        setCart(response.cart);
        setInitialCart(response.cart);
        setUpdated(false);
      }
    )
  }

  function handleCheckout(type) {
    const navigateToCheckout = () => window.location.href = Drupal.url('checkout/' + cart.id)

    if (type === checkout?.checkoutType) {
      navigateToCheckout()
      return
    }

    Api.patch(`api/checkout/${cart.id}`, {checkoutType: type}).then(() => navigateToCheckout())
  }

  const total = cart.total_price;
  const subtotal = cart.subtotal_price;
  const adjustments = cart.adjustments ?? [];
  const hasAdjustments = adjustments.length > 0;
  const availableCheckoutTypes = checkout?.availableCheckoutTypes ?? []
  const hasInvalidQty = availableCheckoutTypes.length === 1 && availableCheckoutTypes[0] === 'preventivo'

  function handleOpenRemoveModal(id) {
    setItemIdToRemove(id);
    setShowRemoveModal(true);
  }

  function handleConfirmRemove() {
    if (itemIdToRemove !== null) {
      handleDeleteItem(itemIdToRemove);
    }
    setShowRemoveModal(false);
    setItemIdToRemove(null);
  }

  function handleCancelRemove() {
    setShowRemoveModal(false);
    setItemIdToRemove(null);
  }

  return <div className="cart-wrapper">
    <div className="cart-products-wrapper">
      <div className="cart-product-variations">
        {(!cart?.items || cart.items.length === 0) ? (
          <div className="cart-empty-message text-center p-4">
            {Drupal.tt('Il tuo carrello è vuoto')}
          </div>
        ) : (
          cart.items.map(cartItem => {
            return <CartProductVariationItem
              key={cartItem.id}
              productVariation={cartItem.product_variation}
              quantity={cartItem.quantity}
              onChange={newQty => {
                handleCartUpdate(cartItem.id, newQty)
              }}
              onDeleteButtonClick={() => {
                handleOpenRemoveModal(cartItem.id);
              }}
            />
          })
        )}
      </div>
      {/* todo Pagination? */}
    </div>
    <CartRemoveItemConfirmationModal
      show={showRemoveModal}
      onConfirm={handleConfirmRemove}
      onCancel={handleCancelRemove}
    />
    {total && (
      <div className="cart-total">
        {hasAdjustments && subtotal && (
          <div className='subtotal'>
            <span className='label'>{Drupal.tt('Subtotale')}</span>
            <span className='price'><Price value={subtotal}/></span>
          </div>
        )}
        {adjustments.map((adj, i) => (
          <div key={i} className='adjustment'>
            <span className='label'>{adj.label}</span>
            <span className='price'><Price value={adj.amount}/></span>
          </div>
        ))}
        <div className='total'>
          <span className='label'>{Drupal.tt('Totale')}</span>
          <span className='price'><Price value={total}/></span>
        </div>
        {hasInvalidQty && <InvalidQtyMessage />}
      </div>
    )}
    <div className='cart-actions'>
      {updated && <>
        <button className="btn btn-secondary" disabled={!updated} onClick={handleResetCart}>{Drupal.tt('Annulla')}</button>
        <button className="btn btn-secondary" disabled={!updated} onClick={handleSaveCart}>{Drupal.tt('Salva')}</button>
      </>}

      {!updated && total && <>
        <button
          className="btn btn-primary"
          onClick={() => handleCheckout('preventivo')}
          disabled={!availableCheckoutTypes.includes('preventivo')}
        >{Drupal.tt('Richiedi preventivo')}</button>

        <button
          className="btn btn-primary"
          onClick={() => handleCheckout('ordine')}
          disabled={!availableCheckoutTypes.includes('ordine')}
        >
          {Drupal.tt('Checkout')}
        </button>
      </>}
    </div>
  </div>
}
